<template>
    <div class="file-uploader">
        <drop-area
            v-if="showDropzone"
            :drop-options="dropOptions"
            @fileSaved="dropzoneAdd"
            @error="$emit('error', $event)"
        >
            <template v-slot:title><slot name="title"></slot></template>
        </drop-area>
        <template v-if="showList">
            <media-list-item
                v-for="file in filesToShowInList"
                :file="file"
                :key="file.serverUuid"
                @download="download($event)"
                @remove="remove($event)"
                :can-preview="false"
                :can-delete="true"
                :locale="locale"
            />
        </template>
    </div>
</template>

<script>
import FileUploaderBase from '../common/FileUploaderBase'
import uploaderProps from '../../mixins/uploaderProps'
import DropArea from '../common/DropArea'
import MediaListItem from './MediaListItem'
import {sanitizeUrl, streamFile} from '../../services/helpers'
import File from '../common/File'
import {downloadEmailAttachment, downloadEmailAttachmentWhenEdit} from '../../repositories/emailAttachmentRepository'

export default {
    extends: FileUploaderBase,
    mixins: [uploaderProps],
    name: "FileUploaderMailbox",
    props: {
        mailboxUuid: String,
        messageUuid: String,
    },
    components: {
        DropArea,
        MediaListItem,
    },
    computed: {
        dropOptions() {
            return {
                url: sanitizeUrl(`${this.baseURL}/mailbox/${this.mailboxUuid}/attachment`),
                headers: {
                    Authorization: this.auth
                },
                uploadMultiple: true,
                paramName: 'files',
                ...this.dropzoneOptions,
                ...this.translations
            }
        },
        savedFiles() {
            return this.proxyFiles.map(f => {
                return {
                    extension: f.ext,
                    id: f.serverUuid,
                    name: `${f.name}.${f.ext}`,
                    realPath: null,
                    thumbnailUrl: f.thumbnailUrl
                }
            });
        },
    },
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(files) {
                for (let file of files) {
                    if (file.id && false === this.proxyFiles.map(f => f.serverUuid).includes(file.id)) {
                        this.proxyFiles.push(
                            new File(file.id, null, file.name.split('.')[0], file.extension, null, null)
                        );
                    }
                }
                // remove proxy data that don't exist in model
                const modelFiles = files.map(f => f.id);
                this.proxyFiles = this.proxyFiles.filter(file => modelFiles.includes(file.serverUuid))
            }
        }
    },
    methods: {
        download(file) {
            const idx = this.getFileIndexByServerUuid(file.serverUuid);
            this.proxyFiles[idx].isDownloading = true;
            // osobne endpointy dla trybów edycji/odczytu
            if (this.showDrop === false) {
                downloadEmailAttachment(this.messageUuid, file.serverUuid).then(({response}) => {
                        this.proxyFiles[idx].isDownloading = false
                        streamFile(response)
                });
            } else {
                downloadEmailAttachmentWhenEdit(this.mailboxUuid, file.serverUuid, `${file.name}.${file.ext}`).then(({response}) => {
                    this.proxyFiles[idx].isDownloading = false;
                    streamFile(response);
                })
            }
        },
        dropzoneAdd({file, response}) {
            const f = new File(
                response[0].id,
                null,
                file.name.split('.')[0],
                file.name.split('.').pop(),
                file.size,
                file.type
            );
            f.thumbnailUrl = file.dataURL || null;
            const alreadyAdded = this.proxyFiles.map(file => file.serverUuid);
            if (false === alreadyAdded.includes(response[0].id)) {
                this.proxyFiles.push(f);
            }
        },
    }
}
</script>

<style lang="scss">
    @import '~vue2-dropzone/dist/vue2Dropzone.min.css';
    @import '~font-awesome/css/font-awesome.css';
    @import '~vue-cool-lightbox/dist/vue-cool-lightbox.min.css';
    @import '../../assets/scss/main.scss';
</style>